(() => {
  'use strict';

  const ROOT = document.documentElement;
  const ATTRIBUTE = 'data-mezetto-theme';
  const STORAGE_KEY = 'mezetto-theme';
  const THEMES = new Set(['light', 'dark']);
  const MEDIA_QUERY = window.matchMedia
    ? window.matchMedia('(prefers-color-scheme: dark)')
    : null;

  const safeStorage = {
    get() {
      try {
        const value = window.localStorage.getItem(STORAGE_KEY);
        return THEMES.has(value) ? value : null;
      } catch (error) {
        return null;
      }
    },

    set(value) {
      try {
        window.localStorage.setItem(STORAGE_KEY, value);
      } catch (error) {
        // Gizli mod veya kısıtlı depolama durumunda sessizce devam et.
      }
    }
  };

  const systemTheme = () => (MEDIA_QUERY && MEDIA_QUERY.matches ? 'dark' : 'light');

  const resolvedTheme = () => {
    const stored = safeStorage.get();
    if (stored) return stored;

    const current = ROOT.getAttribute(ATTRIBUTE);
    if (THEMES.has(current)) return current;

    return systemTheme();
  };

  const updateButton = (button, theme) => {
    const isDark = theme === 'dark';
    const label = isDark ? 'Gündüz moduna geç' : 'Gece moduna geç';

    button.setAttribute('aria-pressed', String(isDark));
    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);

    const text = button.querySelector('[data-mezetto-theme-label]');
    if (text) text.textContent = label;
  };

  const updateAllButtons = (theme) => {
    document.querySelectorAll('[data-mezetto-theme-toggle]').forEach((button) => {
      updateButton(button, theme);
    });
  };

  const applyTheme = (theme, options = {}) => {
    const nextTheme = THEMES.has(theme) ? theme : 'light';
    const { persist = false, animate = false } = options;

    if (animate) {
      ROOT.classList.add('mezetto-theme-transition');
      window.setTimeout(() => {
        ROOT.classList.remove('mezetto-theme-transition');
      }, 320);
    }

    ROOT.setAttribute(ATTRIBUTE, nextTheme);
    ROOT.style.colorScheme = nextTheme;

    if (persist) safeStorage.set(nextTheme);

    updateAllButtons(nextTheme);

    window.dispatchEvent(
      new CustomEvent('mezetto:theme:change', {
        detail: {
          theme: nextTheme,
          stored: Boolean(safeStorage.get())
        }
      })
    );
  };

  const bindButton = (button) => {
    if (button.dataset.mezettoThemeBound === 'true') {
      updateButton(button, resolvedTheme());
      return;
    }

    button.dataset.mezettoThemeBound = 'true';

    button.addEventListener('click', () => {
      const current = resolvedTheme();
      const next = current === 'dark' ? 'light' : 'dark';
      applyTheme(next, { persist: true, animate: true });
    });

    updateButton(button, resolvedTheme());
  };

  const bindAllButtons = (scope = document) => {
    scope.querySelectorAll('[data-mezetto-theme-toggle]').forEach(bindButton);
  };

  const init = () => {
    applyTheme(resolvedTheme());
    bindAllButtons();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    bindAllButtons(event.target);
    updateAllButtons(resolvedTheme());
  });

  window.addEventListener('storage', (event) => {
    if (event.key !== STORAGE_KEY) return;

    const nextTheme = THEMES.has(event.newValue) ? event.newValue : systemTheme();
    applyTheme(nextTheme);
  });

  if (MEDIA_QUERY) {
    const handleSystemChange = (event) => {
      if (safeStorage.get()) return;
      applyTheme(event.matches ? 'dark' : 'light', { animate: true });
    };

    if (typeof MEDIA_QUERY.addEventListener === 'function') {
      MEDIA_QUERY.addEventListener('change', handleSystemChange);
    } else if (typeof MEDIA_QUERY.addListener === 'function') {
      MEDIA_QUERY.addListener(handleSystemChange);
    }
  }
})();